var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from "react";
import { useMutation, useQuery } from "react-query";
import { liveChat } from "@jti/fe-clients";
import { CasAuthApi, getUser } from "@jti/rest-api";
export const useRegister = () => {
    const callRegister = useMutation("register", ({ registerData, dobFormat }) => CasAuthApi.init().register(registerData, dobFormat));
    const register = useCallback((data, dobFormat) => __awaiter(void 0, void 0, void 0, function* () { return yield callRegister.mutateAsync({ registerData: data, dobFormat }); }), [callRegister]);
    return { register };
};
export const useRegisterCdpUser = () => {
    const callRegister = useMutation("register", (data) => CasAuthApi.init().registerCdpUser(data));
    const registerCdp = useCallback((data) => __awaiter(void 0, void 0, void 0, function* () { return yield callRegister.mutateAsync(data); }), [callRegister]);
    return { registerCdp };
};
export const useGrantAccess = () => {
    const { ciam_token } = getUser();
    const { isLoading, isSuccess } = useQuery("validate", () => CasAuthApi.init().validate(ciam_token), {
        retry: false,
        refetchOnWindowFocus: false,
    });
    return { isGranted: isSuccess, isLoading };
};
export const useLogin = () => {
    const callLogin = useMutation("login", (variables) => CasAuthApi.init().login(variables));
    const login = useCallback((data) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield callLogin.mutateAsync(data);
        liveChat.onLogin();
        return response;
    }), [callLogin]);
    return {
        login,
        error: callLogin.error,
        isLoading: callLogin.isLoading,
        isFailed: callLogin.isError,
        isSuccess: callLogin.isSuccess,
    };
};
export const useAccountCancelation = () => {
    const { uuid } = getUser();
    const cancelUserAccountMutation = useMutation("cancelUserAccount", ({ externalUserIdentifier, ciamToken }) => CasAuthApi.init().unregister(externalUserIdentifier || uuid, ciamToken));
    const cancelUserAccount = useCallback((externalUserIdentifier, ciamToken) => __awaiter(void 0, void 0, void 0, function* () { return yield cancelUserAccountMutation.mutateAsync({ externalUserIdentifier, ciamToken }); }), [cancelUserAccountMutation]);
    return { cancelUserAccount };
};
export const useVerifyConsumer = () => {
    const { isLoading, mutateAsync } = useMutation("verifyConsumer", (email) => CasAuthApi.init().verifyConsumer(email));
    const verifyConsumer = useCallback((email) => __awaiter(void 0, void 0, void 0, function* () { return yield mutateAsync(email); }), [mutateAsync]);
    return {
        verifyConsumer,
        isLoading,
    };
};
